import React, {FC} from 'react'
import {Alert, Button, Card} from 'react-bootstrap'
import {KTSVG, toAbsoluteUrl} from '../../../../_metronic/helpers'
import {StringIsNullOrEmpty} from '../../Common/Util'

type PlaceholderProps = {
  type: string
  subtitle?: string
  title: string
  description: string
  image?: string
  biIcon?: string
  dtIcon?: string
  faIcon?: string
}

const Placeholderize: FC<PlaceholderProps> = ({type, subtitle, title, description, image, biIcon, dtIcon, faIcon}) => {
  return (
    <div className='d-flex flex-column align-items-center justify-content-center h-100'>
      {image && <img className='h-50px my-1 my-lg-2' src={toAbsoluteUrl(image)} />}
      {biIcon && <i className={`${biIcon} fa-3x mb-5 text-${type}`}></i>}
      {dtIcon && <KTSVG path={`/media/icons/duotune/${dtIcon}.svg`} className={`svg-icon svg-icon-5x mb-5 text-${type}`} />}
      {faIcon && <i className={`${faIcon} fa-fw fa-3x mb-5 text-${type}`}></i>}
      {!StringIsNullOrEmpty(subtitle) && <div className='fs-7 fw-normal lh-1'>{subtitle}</div>}
      {!StringIsNullOrEmpty(title) && <Card.Title className='text-dark fw-bolder fs-3 mb-2'>{title}</Card.Title>}
      {!StringIsNullOrEmpty(description) && <Card.Subtitle className='text-muted fw-semibold text-center'>{description}</Card.Subtitle>}
    </div>
  )
}

Placeholderize.defaultProps = {}

export default Placeholderize
